import React, { useMemo }  from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { Rates } from '../../../api/services/next';

const RatesDropDown = ({HotelId, HotelIds, ...props}) => {
    const spec = useMemo(()=>{
        return HotelIds?{
          HotelIds
        }:{
          HotelId
        }
    }, [HotelId, HotelIds])
    return <DropDown search={false} api={Rates.GetRates} spec={spec} textField="Name" valueField="Id"  {...props}/>
}

RatesDropDown.propTypes = {
  HotelId: PropTypes.any,
  HotelIds: PropTypes.any
}

export default RatesDropDown